import React, { forwardRef, useImperativeHandle } from 'react';
import { Backdrop, Box, Button, Typography } from "@mui/material";
import Modal from '@mui/material/Modal';
import colors from '../styles/colors';
import CircularProgress from '@mui/material/CircularProgress';


const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 2,
  borderRadius: 4,
};

const LoadingModal = ({ isLoading, message = 'Loading data...' }) => {

  return (
    <>
      <Modal
        open={isLoading}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Box
          sx={[modalStyle, { display: 'flex', flexDirection: 'column', alignItems: 'center' }]}
        >
          <CircularProgress sx={{ color: colors.primary, mb: '10px' }} />
          <Typography variant="subtitle1" component="div">
            {message}
          </Typography>

        </Box >
      </Modal >
    </>
  );
};

export default LoadingModal;
